<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Ubah Jenis Dokumen" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Dokumen<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Nama" 
                    required 
                    outlined 
                    v-model="ubahForm.nama"
                    @input="$v.ubahForm.nama.$touch()"
                    @blur="$v.ubahForm.nama.$touch()"
                    :error-messages="namaErrors"
                  />
                  <span style="color:red;">{{errorMessageNama}}</span>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Pilih Alur<span style="color: red">*</span></p>
                  <v-select
                    dense
                    :items="listAlurPersetujuan"
                    v-model="ubahForm.alur_persetujuan"
                    placeholder="Pilih Alur Persetujuan"
                    required
                    outlined
                    @input="$v.ubahForm.alur_persetujuan.$touch()"
                    @blur="$v.ubahForm.alur_persetujuan.$touch()"
                    >
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Status</p>
                  <v-checkbox v-model="ubahForm.status" v-if="ubahForm.status === true" label="Aktif"/> 
                  <v-checkbox v-model="ubahForm.status" v-else-if="ubahForm.status === false" label="Tidak Aktif"/>
                </div>
              </v-col>
              
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp
                <v-btn color="primary" @click="updateData()">Simpan</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
            {{ snackbarText }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </material-card>
      </div>

    </v-container>
  </template>
  
  <script>
  import { apiServer } from "../../setup-axios";
  import {maxLength, required, helpers} from "vuelidate/lib/validators";

  const regexNama = helpers.regex('regexNama', /^[a-z\d_\/\s-]+$/i);

  export default {
    data: () => ({
      // items: ['Test 1', 'Test 2', 'Test 3'],
      ubahForm: {
        nama: '',
        alur_persetujuan: '',
        status: false
      },
      errorMessageNama:'',
      // status:false,
      listAlurPersetujuan: [],
      formError:false,
      errorCounter:0,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
    }),
    created() {
      this.getDropdownAlurPersetujuan()
    }, 
    mounted() {
        this.getData()
    },
    validations: {
      ubahForm: {
        nama: {
          required,
          maxLength: maxLength(255),
          regexNama
        },
        alur_persetujuan: {
          required,
        },
      }
    },
    computed: {
      namaErrors() {
        const errors = [];
        if (!this.$v.ubahForm.nama.$dirty) return errors;
        !this.$v.ubahForm.nama.required &&
        errors.push("Nama harus diisi");
        !this.$v.ubahForm.nama.maxLength &&
        errors.push("Nama maksimal 255 karakter");
        !this.$v.ubahForm.nama.regexNama &&
        errors.push("Nama hanya boleh mengandung huruf, angka, spasi, -, _, dan /");
        
        return errors;
      },
    },
    methods: {
      getData() {
        apiServer
          .get("/jenis_dokumen/" + this.$route.params.id)
          .then(response => {
            console.log(response.data.data)
            // this.status = response.data.data.status
            this.ubahForm = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      getDropdownAlurPersetujuan() {
        apiServer
          .get("/jenis_dokumen/dropdown_alur_persetujuan")
          .then(response => {
            console.log("get dropdown_alur_persetujuan: ", response.data.data)
            this.listAlurPersetujuan = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      updateData() {
        // this.ubahForm.status = this.status;
        this.ubahForm.nama = this.ubahForm.nama.trim(" ")
        console.log(JSON.stringify(this.ubahForm))
        apiServer
          .put("/jenis_dokumen/update", this.ubahForm)
          .then(response => {
            console.log("update success: ", JSON.stringify(response))
            this.sendSnackbar("orange", "Jenis dokumen  "+ this.ubahForm.nama +" berhasil diubah");
            this.$router.push('/jenis-dokumen')
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
            if (error.response.data.message.includes("sudah ada")){
              console.log("error edit nama")
              this.errorMessageNama = error.response.data.message
            } else {
              this.showSnackbar(
                "error",
                "Error, please contact your administrator!"
              );
            }
            
            
            // console.log(this.snackbar);
            // console.log(this.snackbarText);
            // console.log(this.snackbarColor);
          });
      },
      cancel() {
        this.$router.push('/jenis-dokumen')
      },
      sendSnackbar(color, message) {
        this.$store.dispatch('setSnackbar', {
          snackbarColor: color,
          snackbarText: message,
        })
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
    }
  }
</script>